import { ApplicationMuiTheme } from '@tassat/payments-themes/dist/types/theme';

export const isSSOAuthenticationObj = (auth: ApplicationMuiTheme['app']['clientTheme']['features']['Authentication']) => {
    if ('SSOConfig' in auth) {
        return auth?.SSOConfig;
    }
};